import { NotificationManager } from "react-notifications";
import { Actions as INTEGRATION_ACTIONS } from "../../../../store/actions/integrationActions";
import { checkStepFunctionStatus } from "../../../../store/actions/notificationActions";

import cleanDeep from "clean-deep";
import { createRequest } from "@/common/helpers/RequestHelpers";
import { camelCase } from "lodash";
import apiURL, { domain } from "../../../../store/actions/apiURL";
import { constructQueryParams, toTitleCase } from "@/common/validation/Validators";

const MOCK_INTEGRATION = window.localStorage.getItem("MOCK_NEST_INTEGRATION") && ["local", "review"].includes(domain);
const LOG_MOCK = window.localStorage.getItem("LOG_MOCK");

const mockIntegration = ({ path, method, query }) => {
	const mock = method + path + constructQueryParams(query);
	if (LOG_MOCK) NotificationManager.info(`Mocking ${mock}`, "Mocking");

	return new Promise((resolve, reject) => {
		const mockObject = {
		};

		// randomise the timeout duration between 300ms and 2500ms
		const timeout = Math.floor(Math.random() * 2200) + 300;

		setTimeout(() => {
			if (!mockObject[mock]) reject({ response: { data: { error: "No mock data found" } } });
			resolve({
				data: mockObject[mock],
			});
		}, timeout);
	});
};

const integrationRequest = createRequest({
	urlPath: "/integrations",
	// local: true,
});

const Types = {
	ACCOUNTING_INTEGRATION_UPDATE_CONNECTION: "ACCOUNTING_INTEGRATION_UPDATE_CONNECTION",
	ACCOUNTING_INTEGRATION_UPDATE_EMPLOYEE: "ACCOUNTING_INTEGRATION_UPDATE_EMPLOYEE",
	ACCOUNTING_INTEGRATION_UNSYNCED_EMPLOYEE: "ACCOUNTING_INTEGRATION_UNSYNCED_EMPLOYEE",
	ACCOUNTING_INTEGRATION_SYNCING_STATUS: "ACCOUNTING_INTEGRATION_SYNCING_STATUS",
	ACCOUNTING_INTEGRATION_SENDING_PAY_PERIOD: "ACCOUNTING_INTEGRATION_SENDING_PAY_PERIOD",
	ACCOUNTING_INTEGRATION_COMPANIES: "ACCOUNTING_INTEGRATION_COMPANIES",
	ACCOUNTING_INTEGRATION_ACCOUNTS: "ACCOUNTING_INTEGRATION_ACCOUNTS",
	ACCOUNTING_INTEGRATION_SAVE: "ACCOUNTING_INTEGRATION_SAVE",
	ACCOUNTING_INTEGRATION_SAVING: "ACCOUNTING_INTEGRATION_SAVING",
	ACCOUNTING_INTEGRATION_UPDATE_FIELD: "ACCOUNTING_INTEGRATION_UPDATE_FIELD",
};

const saveComplete = (integration, data) => ({
	type: Types.ACCOUNTING_INTEGRATION_SAVE,
	integration,
	data,
});

const saving = (integration) => ({
	type: Types.ACCOUNTING_INTEGRATION_SAVING,
	integration,
});

const updateField = (integration, field, value) => ({
	type: Types.ACCOUNTING_INTEGRATION_UPDATE_FIELD,
	integration: camelCase(integration),
	field,
	value,
});

const connectAccountingIntegration = (integration, credentials) => {

	console.log('connectAccountingIntegration', integration)
	return (dispatch, getState) => {
		const integrationCamelCase = camelCase(integration);

		integrationRequest({
			method: "GET",
			path: `/${integrationCamelCase}/new`,
		})
			.then(({ data }) => {
				if (!data.url) {
					NotificationManager.error(`Error Connecting ${integration}`, `Connect ${integration}`);
					return;
				}
				if (!data.url.startsWith("https://api.buddy.hr") && !data.url.startsWith("http://localhost")) {
					window.open(data.url, "_self");
				} else {
					const url = data.url.replace("https://api.buddy.hr/", "").replace("http://localhost:3001/", "");
					const [version, ...rest] = url.split("/");
					const reconstructedURL = rest.join("/").replace("integrations/", "");

					integrationRequest({
						method: "GET",
						path: `/${reconstructedURL}`,
						query: credentials,
					}).then((data) => {
						dispatch(INTEGRATION_ACTIONS.integrationGetList());
					});
				}
			})
			.catch((error) => {
				console.error(error);
				const body = error.response.data;
				NotificationManager.error(
					`Error Connecting ${integration}${body.error ? " - " + body.error : ""}`,
					`Connect ${integration}`,
				);
			});

		// if (true) {
		// 	// assumed oAuth 2.0 flow try to setup a new connection
		// 	window.open(apiURL + `/integrations/${integrationCamelCase}/new`, "_self");
		// } else {
		// 	// this starts a new connection (/connect is the callback url)
		// 	fetch(apiURL + `/integrations/${integrationCamelCase}/connect`, {
		// 		credentials: "include",
		// 		method: "GET",
		// 		headers: {
		// 			"Accept": "application/json",
		// 			"Content-Type": "application/json",
		// 		},
		// 	})
		// 		.then((response) => response.json())
		// 		.then((data) => {
		// 			window.open(data.url, "_blank");
		// 			dispatch(COMPANY_ACTIONS.getCompanySettings());
		// 		})
		// 		.catch((error) => {
		// 			console.error(error);
		// 			NotificationManager.error(`Error Connecting ${integration}`, `Connect ${integration}`);
		// 		});
		// }
	};
};

const verifyConnection = (integration) => {
	return (dispatch, getState) => {
		const integrationCamelCase = camelCase(integration);

		integrationRequest({
			method: "GET",
			path: `/${integrationCamelCase}/verify-connection`,
		})
			.then(({ data }) => {
				switch (data.status) {
					case "Pending":
						NotificationManager.info(
							`Connection With ${integration} Is Still Pending`,
							`Connect ${integration}`,
						);
						break;
					case "Connected":
						NotificationManager.success(`Successfully Connected ${integration}`, `Connect ${integration}`);
						dispatch(INTEGRATION_ACTIONS.integrationGetList());
						break;
					case "Error":
						NotificationManager.error(`Error Connecting ${integration}`, `Connect ${integration}`);
						break;
				}
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error(`Error Verifying Connection With ${integration}`, `Connect ${integration}`);
			});
	};
};

const disconnectAccountingIntegration = (integration) => {
	return (dispatch, getState) => {
		const integrationCamelCase = camelCase(integration);

		integrationRequest({
			method: "DELETE",
			path: `/${integrationCamelCase}/`,
		})
			.then(() => {
				dispatch(INTEGRATION_ACTIONS.integrationGetList());
				NotificationManager.success(`Successfully Disconnected ${integration}`, `Disconnect ${integration}`);
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error(`Error Disconnecting ${integration}`, `Disconnect ${integration}`);
			});
	};
};

const sendingPayPeriod = (integration, periodId, status) => ({
	type: Types.ACCOUNTING_INTEGRATION_SENDING_PAY_PERIOD,
	integration,
	periodId,
	status,
});

const updatePayPeriod = (integration, period) => ({
	type: Types.ACCOUNTING_INTEGRATION_UPDATE_PAY_PERIOD,
	integration,
	period,
});

const pushPollToList = (integration, poll) => ({
	type: Types.ACCOUNTING_INTEGRATION_PUSH_POLL_LIST,
	integration,
	poll,
});

const setPollList = (integration, polls) => ({
	type: Types.ACCOUNTING_INTEGRATION_SET_POLL_LIST,
	integration,
	polls,
});

const sendPayPeriodToAccountingIntegration = (integration, periodId) => {
	return async (dispatch, getState) => {
		const integrationCamelCase = camelCase(integration);

		const state = getState();
		const sending = state.integration?.accounting?.[integrationCamelCase]?.sendingPayroll || [];

		if (sending.includes(periodId)) return;

		dispatch(sendingPayPeriod(integrationCamelCase, periodId, true));

		await integrationRequest({
			method: "POST",
			path: `/${integrationCamelCase}/payroll`,
			body: { payPeriodId: periodId }
		})
			.then(({ data }) => {
				if (data.arn){
					checkStepFunctionStatus(data.arn, (response) => {
						if (response.output) {
							try {
								const output = JSON.parse(response.output);
								dispatch(updatePayPeriod(integrationCamelCase, output.payPeriod));
								dispatch(sendingPayPeriod(integrationCamelCase, periodId));
							} catch (e) {
								console.log('error', e)
								NotificationManager.error(
									`Error Sending Pay Period to ${integration}`,
									`Send Pay Period to ${integration}`,
								);
							}
						}
					});
				} else {
					dispatch(updatePayPeriod(integrationCamelCase, data.payPeriod));
					dispatch(sendingPayPeriod(integrationCamelCase, periodId));
				}
			})
			.catch((error) => {
				let message;
				if (error.isAxiosError) {
					message = error.response?.data?.error;
				} else {
					console.error(error);
				}
				NotificationManager.error(
					message ? message : `Error Sending Pay Period to ${integration}`,
					`Send Pay Period to ${integration}`,
				);

				dispatch(sendingPayPeriod(integrationCamelCase, periodId));
			});

	};
};


const importAccountingCategoriesAndCostCenters = (integration, query = {}) => {
	return async (dispatch, getState) => {
		const integrationCamelCase = camelCase(integration);
		const isModalOpen = getState().integration.accounting[integrationCamelCase].pollActionModal;

		integrationRequest({
			method: "GET",
			path: `/${integrationCamelCase}/import`,
			query,
		})
			.then(({ data }) => {
				if (data.arn){
					checkStepFunctionStatus(data.arn, (response) => {
						NotificationManager.success(`Successfully Imported Accounting Categories and Cost Centers`, `Import Accounting Categories and Cost Centers`);
					});
				}
				if (data.poll) {
					dispatch(pushPollToList(integrationCamelCase, data.poll));
				}
				if (data.data) {
					NotificationManager.success(`Successfully Imported Accounting Categories and Cost Centers`, `Import Accounting Categories and Cost Centers`);
				}
			})
			.catch((error) => {
				console.error(error);
				if (error?.response?.data?.poll) {
					dispatch(pushPollToList(integrationCamelCase, error.response.data.poll));
				}
				NotificationManager.error(`Error Importing Accounting Categories and Cost Centers`, `Import Accounting Categories and Cost Centers`);
			});
	};
};

const save = (integration, data) => {
	return async (dispatch, getState) => {
		let state = getState();

		const integrationCamelCase = camelCase(integration);
		dispatch(saving(integration));

		fetch(apiURL + `/integrations/${integrationCamelCase}`, {
			credentials: "include",
			method: "POST",
			body: JSON.stringify(cleanDeep(data)),
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((response) => response.json())
			.then((data) => {
				dispatch(saveComplete(integration, data));
			})
			.catch((error) => {
				console.error(error);
				dispatch(saveComplete(integration, {}));
				NotificationManager.error("Error Saving", `Unable to save your ${integration} settings`);
			});
	};
};

const Actions = {
	connectAccountingIntegration,
	disconnectAccountingIntegration,
	verifyConnection,
	save,
	updateField,
	importAccountingCategoriesAndCostCenters,
	sendPayPeriodToAccountingIntegration,
};

export { Actions, Types };
